import React, { useState } from "react";
import {
  Box,
  useTheme,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import ContainerBlock from "../core/ContainerBlock";
const NAV_LINKS = [
  { to: "/#whatwedo", label: "What We Do", title: "What We Do" },
  { to: "/#howitworks", label: "How It Works", title: "How It Works" },
  { to: "/#faqs", label: "FAQs", title: "FAQs" },
  { to: "/#contact", label: "Contact", title: "Contact" },
];

const Header = () => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {NAV_LINKS.map((item) => (
          <ListItem key={item.to} disablePadding>
            <Link
              to={item.to}
              title={item.title}
              style={{
                textDecoration: "none",
                color: theme.palette.text.primary,
                width: "100%",
                display: "block",
                padding: "12px 16px",
              }}
            >
              <ListItemText primary={item.label} />
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.secondary.main,
        padding: { xs: "16px 20px", md: "15px 40px" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1200,
      }}
    >
      {/* Mobile Hamburger */}
      <IconButton
        edge="start"
        aria-label="menu"
        sx={{ display: { xs: "block", md: "none" }, color: "#000000" }}
        onClick={toggleDrawer(true)}
      >
        <MenuIcon sx={{ color: theme.palette.primary.main }} />
      </IconButton>
      <Box
        component="a"
        href="/"
        sx={{
          display: { xs: "inline-flex", md: "none" },
          alignItems: "center",
          width: { xs: "101px", md: "167px" },
          maxHeight: { xs: "60px", md: "100px" },
          position: { xs: "absolute", md: "static" },
          left: { xs: "50%" },
          transform: { xs: "translateX(-50%)", md: "none" },
          textDecoration: "none",
        }}
      >
        <StaticImage
          src="../../static/logos/logo.png"
          alt="Logo"
          placeholder="blurred"
          loading="lazy"
          style={{
            width: "100%",
            height: "auto",
          }}
          imgStyle={{ objectFit: "contain" }}
        />
      </Box>
      <ContainerBlock sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo / Title */}
        <Box
          component={"a"}
          href="/"
          sx={{
            color: theme.palette.background.default,
            fontSize: "24px",
            fontWeight: 500,
            width: { xs: "127px", md: "167px" },
            maxHeight: "100px",
            position: { xs: "absolute", md: "static" },
            left: { xs: "50%" },
            transform: { xs: "translateX(-50%)", md: "none" },
            textAlign: "center",
            textDecoration: "none",
            display: { xs: "none", md: "block" },
          }}
        >
          <StaticImage
            src="../../static/logos/logo.png"
            alt="Logo"
            placeholder="blurred"
            loading="lazy"
            style={{
              width: "100%",
              height: "auto",
            }}
            imgStyle={{ objectFit: "contain" }}
          />
        </Box>

        {/* Desktop Links */}
        <Box
          sx={{
            color: theme.palette.background.default,
            display: { xs: "none", md: "flex" },
            gap: { lg: "10px", xl: "50px" },
            alignItems: "center",
          }}
        >
          {NAV_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              title={item.title}
              partiallyActive={true}
              style={{
                textDecoration: "none",
                color: theme.palette.text.primary,
                padding: "0px 12px",
                fontSize: "15px",
                fontWeight: 500,
              }}
              activeStyle={{ color: theme.palette.primary.main }}
            >
              <Box
                sx={{
                  "&:hover": { color: (theme) => theme.palette.text.secondary },
                }}
              >
                {item.label}
              </Box>
            </Link>
          ))}
          <Button
            component="a"
            href={process.env.GATSBY_JOIN_AS_WORKER_REQUEST_FORM_URL}
            target="_blank"
            disableElevation
            sx={{
              p: "10px 15px",
              fontSize: "16px",
              fontWeight: 500,
              color: "#101828",
              borderRadius: "12px",
              textTransform: "none",
              backgroundColor: "#FFFFFF",
              border: "1.5px solid #101828",
              "&:hover": {
                background: "rgba(0,0,0,0.1)",
              },
            }}
          >
            Join as Worker
          </Button>
        </Box>
      </ContainerBlock>

      {/* Mobile Drawer */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Header;
